const middleware = {}

middleware['headers'] = require('../middleware/headers.ts')
middleware['headers'] = middleware['headers'].default || middleware['headers']

middleware['navigation'] = require('../middleware/navigation.ts')
middleware['navigation'] = middleware['navigation'].default || middleware['navigation']

export default middleware
